import { Response } from "../api.interface";
import { jdiColorFetch } from "@/apis/colorFetchV2";
import { DeleteResultRes, MessageEnterace, MessageListParam, MessageListResponse, MessagePreviewResponse } from "./message.interface";

// 获取首页消息
export const getMsgPreviewApi = async (): Promise<Response<MessagePreviewResponse>> => {
  return jdiColorFetch(`user_message_getMsgList`, {
    method: "post",
    bodyQuery: {
      appName: "C",
      languageCode: "en_US",
    },
  });
};

// 获取二级页面消息列表
export const getMsgListApi = async ({ currentPage, pageSize, accountType }: MessageListParam): Promise<Response<MessageListResponse>> => {
  return jdiColorFetch(`user_message_getList`, {
    method: "post",
    bodyQuery: {
      appName: "C",
      languageCode: "en_US",
      accountType,
      currentPage,
      pageSize,
    },
  });
};

// 消息删除
export const handleBatchDeleteApi = async ({ msgId }: { msgId: string }): Promise<DeleteResultRes | null> => {
  const res = await jdiColorFetch(`user_message_delete`, {
    method: "post",
    bodyQuery: {
      appName: "C",
      languageCode: "en_US",
      msgId: [msgId],
    },
  });
  return {
    data: res?.code === "200"
  };
};

// 按类型消息已读
export const updateReadStatusApi = async (accountType: number): Promise<DeleteResultRes | null> => {
  const res = await jdiColorFetch(`user_message_markAsRead`, {
    method: "post",
    bodyQuery: {
      appName: "C",
      languageCode: "en_US",
      accountType,
    },
  });
  return {
    data: res?.code === "200"
  };
};

// 小扫把一键清除
export const oneKeyReadApi = async (): Promise<DeleteResultRes | null> => {
  const res = await jdiColorFetch(`user_message_markAllAsRead`, {
    method: "post",
    bodyQuery: {
      appName: "C",
      languageCode: "en_US",
    },
  });
  return {
    data: res?.code === "200"
  };
};

// 获取用户未读消息角标信息
export const fetchGetMsgEntrance = (): Promise<Response<MessageEnterace>> => {
  return jdiColorFetch(`user_message_getMsgUnReadCount`, {
    method: "post",
    bodyQuery: {
      appName: "C",
      languageCode: "en_US",
    },
  });
};
